import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

const ttpRegistriesUrl = `${SERVER_API}/ttp-registries`;
export const ttpCommuneUrl = `${ttpRegistriesUrl}/ttp-commune`;

export const TTP_COMMUNE_API = {
  ...generateCrudEndpoints(ttpCommuneUrl),
  EXCLUDE(id: number | string): IEndpointData {
    return {
      method: 'POST',
      url: `${ttpCommuneUrl}/${id.toString()}/exclude`,
    };
  },
};
